import { h, FunctionComponent } from 'preact';

interface ErrorProps {
  message: string;
}
export const Error: FunctionComponent<ErrorProps> = ({ message }) => (
  <div className="info-block info-block--alert">
    <div className="info-block__icon">
      <svg width={22} height={22} xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.667 11c0 5.892-4.776 10.667-10.667 10.667C5.11 21.667.333 16.892.333 11 .333 5.111 5.11.333 11 .333 16.89.333 21.667 5.111 21.667 11zM11 13.15a1.979 1.979 0 100 3.958 1.979 1.979 0 000-3.957zM9.122 6.04l.319 5.85a.516.516 0 00.515.487h2.088c.274 0 .5-.214.515-.488l.32-5.85a.516.516 0 00-.516-.543H9.637a.516.516 0 00-.515.544z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </svg>
    </div>
    <div className="info-block__text">{message}</div>
  </div>
);
